import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Stack, Typography } from '@mui/material';

type PropTypes = {
  close: () => void;
  confirmAbort: () => void;
  confirmRestart: () => void;
  open: boolean;
};

export const AbortStarterKitDialog = ({
  close,
  confirmAbort,
  confirmRestart,
  open,
}: PropTypes) => {
  useEffect(() => {
    if (!open) return;
    const listener = (e: any) => {
      if (e.code === 'KeyR') {
        e.preventDefault();
        confirmRestart();
      }
      if (e.code === 'KeyA') {
        e.preventDefault();
        confirmAbort();
      }
      if (e.code === 'KeyC') {
        e.preventDefault();
        close();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [open]);

  return (
    <Dialog open={open}>
      <DialogContent>
        <Typography variant="h6">Are you sure you want to abort?</Typography>
      </DialogContent>
      <DialogActions>
        <Stack spacing={2} width="100%">
          <Button
            variant="outlined"
            onClick={confirmRestart}
            fullWidth
            color="success"
          >
            Restart (R)
          </Button>
          <Button
            variant="outlined"
            onClick={confirmAbort}
            fullWidth
            color="info"
          >
            Abort (A)
          </Button>
          <Button variant="outlined" onClick={close} fullWidth>
            Cancel (C)
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
